import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { indexOf } from "lodash";
import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import CommentInfo from "../CommentInfo";

import { severities, capaPriorities, incidentStatuses } from "../CONSTANTS";
import EvidenceDetailsInfo from "../EvidenceDetailsInfo";
import EvidencePreview from "../EvidencePreview";

const ReviewerDetailsInfo = ({
  investigationCompletionDate,
  investigationCompletionSummary,
  severity,
  insuranceApplicable,
  insuranceClaimRaised,
  insuranceClaimAmount,
  insuranceApprovedAmount,
  insuranceUnapprovedAmount,
  cause,
  fireCause,
  avoidable,
  couldAvoidBy,
  environmentalImpact,
  solutionType,
  compliances,
  trainings,
  mitigationMeasures,
  witnessStatements,
  rootCauseDescriptions,
  solutions,
  capas,
  evidences,
  comments,
  investigator,
  incident,
  users = [],
  targetCompletionDate,
  rootCause,
  rootCauseOther,
  area,
  severityPostReview,
  documents,
  immediateCause,
  indirectCause,
  causeIndirect,
  causeIndirectOther,
  causeImmediate,
  causeImmediateOther,
}) => {
  const [panelIndex, setPanelIndex] = useState(0);
  const customOnClick = (eventKey) => {
    setPanelIndex(eventKey === panelIndex ? null : eventKey);
  };
  return (
    <div className="rightIncidentCard">
      <Accordion defaultActiveKey="0" className="incidentDetailAcc">
        <div>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="13"
            onClick={() => customOnClick(13)}
            className={panelIndex === 13 ? "active" : ""}
          >
            Investigation Team{" "}
            <span style={{ float: "right" }}>
              <MdKeyboardArrowRight />
            </span>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="13">
            <Card.Body>
              <ul style={{ listStyle: "none" }} className="p-0">
                <li>
                  <span className="txtgrey">Investigation Leader:</span>
                  <span className="rightData">{userDropdownLabel(investigator)}</span>
                </li>
                <li>
                  <span className="txtgrey">Target Completion Date:</span>
                  <span className="rightData">
                    {DDMMYYYYFormat(targetCompletionDate)}
                  </span>
                </li>
                <li>
                  <span className="txtgrey">Investigation Members:</span>
                  <ul className="teamSection">
                    {incident?.investigationDetails?.investigationMember
                      ?.split(",")
                      ?.map((id) => {
                        const found = users.find((site) => site.id === +id);
                        return (
                          <>
                            {found && (
                              <li className="position-relative emp-section">
                                <span className="empTab">{userDropdownLabel(found)}</span>
                              </li>
                            )}
                          </>
                        );
                      })}
                  </ul>
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </div>
        {(incident?.incidentStatus !== incidentStatuses.investigationProgress ||
          investigationCompletionDate) && (
          <>
            <div>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="0"
                onClick={() => customOnClick(0)}
                className={panelIndex === 0 ? "active" : ""}
              >
                Investigator Details
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <ul style={{ listStyle: "none" }} className="p-0">
                    <li>
                      <span className="txtgrey">Investigated By:</span>
                      <span className="rightData">{userDropdownLabel(investigator)}</span>
                    </li>
                    <li>
                      <span className="txtgrey">Complete Date:</span>
                      <span className="rightData">
                        {formatDDMMYYYYbyYYYYMMDD(investigationCompletionDate)}
                      </span>
                    </li>
                    <li>
                      <span className="txtgrey">Suggested Severity Type:</span>
                      <span className="rightData">{severities[severityPostReview]}</span>
                    </li>
                    <li className="w-100">
                      <span className="txtgrey">Completion Summary:</span>
                      <span className="rightData">{investigationCompletionSummary}</span>
                    </li>
                  </ul>
                </Card.Body>
              </Accordion.Collapse>
            </div>

            <div>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="7"
                onClick={() => customOnClick(7)}
                className={panelIndex === 7 ? "active" : ""}
              >
                Mitigtion Measures{" "}
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="7">
                <Card.Body>
                  {mitigationMeasures?.length ? (
                    mitigationMeasures.map((data, index) => (
                      <ul
                        key={index}
                        style={{ listStyle: "none" }}
                        className="pt-1 border-top"
                      >
                        <li>
                          <span className="txtgrey">Mitigtion Measures:</span>
                          <span className="rightData">{data.value}</span>
                        </li>
                      </ul>
                    ))
                  ) : (
                    <div className="text-danger">No Data Found</div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </div>
            <div>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="8"
                onClick={() => customOnClick(8)}
                className={panelIndex === 8 ? "active" : ""}
              >
                Witness Statements{" "}
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="8">
                <Card.Body>
                  {witnessStatements?.length ? (
                    witnessStatements.map((data, index) => (
                      <ul
                        key={index}
                        style={{ listStyle: "none" }}
                        className="pt-1 border-top"
                      >
                        <li>
                          <span className="txtgrey">Witness Name:</span>
                          <span className="rightData">{data.name}</span>
                        </li>
                        <li>
                          <span className="txtgrey">Date of Statement:</span>
                          <span className="rightData">
                            {formatDDMMYYYYbyYYYYMMDD(data.date)}
                          </span>
                        </li>
                        <li>
                          <span className="txtgrey">Brief Description:</span>
                          <span className="rightData">{data.description}</span>
                        </li>
                        <li>
                          <span className="txtgrey">Statement Evidence:</span>
                          <span className="rightData">
                            {data.file ? (
                              <EvidencePreview type={data.file.type} file={data.file} />
                            ) : null}
                          </span>
                        </li>
                      </ul>
                    ))
                  ) : (
                    <div className="text-danger">No Data Found</div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </div>
            <div>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="9"
                onClick={() => customOnClick(9)}
                className={panelIndex === 9 ? "active" : ""}
              >
                Root Cause Analysis{" "}
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="9">
                <Card.Body>
                  <ul style={{ listStyle: "none" }} className="pt-1 ">
                    <li>
                      <span className="txtgrey">Root Cause:</span>
                      <span className="rightData">{rootCause}</span>
                    </li>
                    {rootCauseOther && (
                      <li>
                        <span className="txtgrey">Root Cause Other:</span>
                        <span className="rightData">{rootCauseOther}</span>
                      </li>
                    )}
                  </ul>
                  {rootCauseDescriptions?.map((data, index) => (
                    <ul key={index} style={{ listStyle: "none" }} className="pt-1">
                      <li>
                        <span className="txtgrey">Description:</span>
                        <span className="rightData">{data.value}</span>
                      </li>
                    </ul>
                  ))}

                  <hr />

                  <ul style={{ listStyle: "none" }} className="pt-1">
                    <li>
                      <span className="txtgrey">Immediate Cause:</span>
                      <span className="rightData">{causeImmediate}</span>
                    </li>
                    {causeImmediateOther && (
                      <li>
                        <span className="txtgrey">Immediate Cause:</span>
                        <span className="rightData">{causeImmediateOther}</span>
                      </li>
                    )}
                  </ul>
                  {immediateCause?.map((data, index) => (
                    <ul key={index} style={{ listStyle: "none" }} className="pt-1 ">
                      <li>
                        <span className="txtgrey">Description:</span>
                        <span className="rightData">{data.value}</span>
                      </li>
                    </ul>
                  ))}
                  <hr />

                  <ul style={{ listStyle: "none" }} className="pt-1">
                    <li>
                      <span className="txtgrey">Indirect Cause:</span>
                      <span className="rightData">{causeIndirect}</span>
                    </li>
                    {causeIndirectOther && (
                      <li>
                        <span className="txtgrey">Indirect Cause Other:</span>
                        <span className="rightData">{causeIndirectOther}</span>
                      </li>
                    )}
                  </ul>
                  {indirectCause?.map((data, index) => (
                    <ul key={index} style={{ listStyle: "none" }} className="pt-1 ">
                      <li>
                        <span className="txtgrey">Description:</span>
                        <span className="rightData">{data.value}</span>
                      </li>
                    </ul>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </div>
            <div>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="12"
                onClick={() => customOnClick(12)}
                className={panelIndex === 12 ? "active" : ""}
              >
                Investigaton Evidence{" "}
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="12">
                <Card.Body>
                  {evidences?.length ? (
                    evidences.map((data) => (
                      <EvidenceDetailsInfo key={data.id} {...data} />
                    ))
                  ) : (
                    <div className="text-danger">No Data Found</div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </div>
            <div>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="15"
                onClick={() => customOnClick(15)}
                className={panelIndex === 15 ? "active" : ""}
              >
                Other Documents{" "}
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="15">
                <Card.Body>
                  {documents?.length ? (
                    documents.map((data) => (
                      <EvidenceDetailsInfo isDocuments key={data.id} {...data} />
                    ))
                  ) : (
                    <div className="text-danger">No Data Found</div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </div>
            <div>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="11"
                onClick={() => customOnClick(11)}
                className={panelIndex === 11 ? "active" : ""}
              >
                Suggested CAPA{" "}
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="11">
                <Card.Body>
                  {incident?.investigationDetails?.suggestedCapa?.capas?.length ? (
                    incident?.investigationDetails?.suggestedCapa?.capas.map(
                      (data, index) => {
                        const areaObj = area?.find((d) => d.id === data.areaId);
                        return (
                          <ul
                            key={indexOf}
                            style={{ listStyle: "none" }}
                            className="pt-1 border-top"
                          >
                            {/* <li>
                            <span className="txtgrey">CAPA ID:</span>
                            <span className="rightData">{data.capaId}</span>
                          </li> */}
                            <li>
                              <span className="txtgrey">CAPA Source:</span>
                              <span className="rightData">{data.source}</span>
                            </li>
                            <li>
                              <span className="txtgrey">Priority:</span>
                              <span className="rightData">
                                {capaPriorities[data.priority]}
                              </span>
                            </li>
                            <li>
                              <span className="txtgrey">Area:</span>
                              <span className="rightData">{areaObj?.name}</span>
                            </li>
                            <li>
                              <span className="txtgrey">Sub Area:</span>
                              <span className="rightData">
                                {data?.subAreaId === 999
                                  ? "Other"
                                  : areaObj?.subAreaOfOperation.find(
                                      (d) => d.id === data.subAreaId
                                    )?.name}
                              </span>
                            </li>
                            {data?.subAreaId === 999 && (
                              <li>
                                <span className="txtgrey">Other Sub Area:</span>
                                <span className="rightData">{data?.otherSubArea}</span>
                              </li>
                            )}
                            <li>
                              <span className="txtgrey">
                                Action Item/ Solution Description:
                              </span>
                              <span className="rightData">{data.solution}</span>
                            </li>
                            {/* <li className="w-100">
                            <span className="txtgrey">Owner Person:</span>
                            <span className="rightData">
                              {userDropdownLabel(data.owner)}
                            </span>
                          </li>
                          <li className="w-100">
                            <span className="txtgrey">Owner Department:</span>
                            <span className="rightData">{data.department?.name}</span>
                          </li>
                          <li className="w-100">
                            <span className="txtgrey">Due Date:</span>
                            <span className="rightData">
                              {formatDDMMYYYYbyYYYYMMDD(data.dueDate)}
                            </span>
                          </li> */}
                          </ul>
                        );
                      }
                    )
                  ) : (
                    <div className="text-danger">No Data Found</div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </div>
          </>
        )}
      </Accordion>
    </div>
  );
};
export default ReviewerDetailsInfo;
